import {TeemillError} from './teemillError';

export class ValidationError extends TeemillError {}
